import searchUsersTemplate from './searchUsers.html';

export default angular
  .module('main.organizations.edit.components.search', [])

  /**
   * Search users form
   */
  .directive('searchUsers', () => {
    return {
      restrict: 'E',
      template: searchUsersTemplate,
      scope: {
        formId: '@', // TODO(alex): We need a function to clean the form
        inputId: '@', // TODO(alex): We need a function focus on search input
        onSelect: '&', // On search callback
        usersList: '=', // Existing list of users/admins
        origin: '=', // Origin of the search (organization, notification group, etc.)
      },
      controller: ($scope,
                   $rootScope,
                   $state,
                   $filter,
                   $log,
                   EditOrganizationDataProvider,
                   utils) => {
        const $t = $filter('translate');

        // TODO(alex): This need to be removed eventually
        $scope.formId = $scope.formId || 'form-search-users';
        $scope.inputId = $scope.inputId || 'input-user-email';

        $scope.dataProvider = EditOrganizationDataProvider.instance;

        angular.extend($scope, {
          searchUsers: searchUsers,
          selectUser: selectUser,
          newUser: newUser,
          newUserParams: {
            from: $scope.origin,
            fromTab: $scope.dataProvider.activeTab,
            email: '',
            phone: '',
          },
          clearAllUsers: clearAllUsers,
        });

        $('#' + $scope.formId).form({
          inline: true,
          fields: {
            'user-email': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.emailPhone')
                }
              ]
            }
          }
        });

        init();

        function init() {
          $scope.loading = true;
          $scope.isOrgAdmins = $scope.dataProvider.activeTab === 'admins';
          initWatchers();
        }

        function initWatchers() {
          $scope.$watch('usersList', (newVal, oldVal) => {
            if (newVal && newVal !== angular.isUndefined) {
              $scope.loading = false;
            }
          });
        }

        function searchUsers() {
          if ($scope.userSearching) {
            return;
          }

          $scope.userSearching = true;
          delete $scope.hideSearchHint;
          delete $scope.searchUserList;
          delete $scope.userExist;

          $('#' + $scope.formId).form('validate form');
          let isFormValid = $('#' + $scope.formId).form('is valid');
          let isValid = isFormValid;

          let isEmail = false;
          let isPhone = false;
          let phoneNumber;

          // Additional email & phone validation
          if (isValid && $scope.userEmailPhone) {
            isEmail = utils.isEmail($scope.userEmailPhone);
            if (!isEmail) {
              phoneNumber = utils.convertPhoneToNumber($scope.userEmailPhone);
              isPhone = !!phoneNumber;
            }
            isValid = isEmail || isPhone;
          }

          if (!isValid) {
            if (isFormValid) {
              $('#' + $scope.formId)
                .form('add prompt', $scope.inputId, $t('prompt.emailPhone'));
            }
            $scope.loading = false;
            $scope.userSearching = false;
            return false;
          }

          return $scope.dataProvider.searchUsersGlobal(isEmail ? $scope.userEmailPhone : void 0, phoneNumber)
            .then(data => {
              $scope.lastSearchedUserEmailPhone = $scope.userEmailPhone;
              $scope.userSearching = false;
              $scope.searchUserList = [];
              if (data.users && data.users.length !== 0) {

                // Filter those users who are in the existing admins list already
                $scope.searchUserList = data.users.filter(u => $scope.usersList
                  ? !$scope.usersList.some(a => {
                    if (a.id === u.id) {
                      $scope.userExist = true;
                      return true;
                    }
                    return false;
                  })
                  : u.id);

              } else {
                // Generate params for new user creation redirect
                $scope.newUserParams.email = isEmail ? $scope.userEmailPhone : '';
                $scope.newUserParams.phone = isPhone ? phoneNumber : '';
              }
            })
            .catch(err => handleError(err));
        }

        /**
         * Trigger the callback function when user selected,
         * and clean the search and the list of users
         * @param {string} user
         */
        function selectUser(user) {
          $scope.loading = true;
          $scope.onSelect({user: user});
          clearSelectedUser(user);
        }

        /**
         * Redirect to create new user page,
         * with optional credentials from the search field
         */
        function newUser($event) {
          $rootScope.$emit('refreshChooseMenuEvent', 'users');
          $state.go('main.users.new', $scope.newUserParams);
        }

        function clearAllUsers() {
          $scope.userEmailPhone = null;
          $scope.hideSearchHint = true;
          $scope.searchUserList = null;
          $scope.newUserParams.email = '';
          $scope.newUserParams.phone = '';
        }

        function clearSelectedUser(user) {
          // Clear email/phone input and result list
          $scope.userEmailPhone = null;
          let index = utils.inArray($scope.searchUserList, 'id', user.id);
          if ($scope.searchUserList.length > 1) {
            $scope.searchUserList.splice(index, 1);
          } else {
            $scope.searchUserList = null;
          }
          $scope.loading = false;
        }

        /**
         * Handle error and stop loading
         */
        function handleError(err) {
          $scope.loading = false;
          $scope.userSearching = false;
          return utils.handleApiError(err);
        }

      }
    };
  })
  .name;
